import env from '../lib/env';
import wandu from '../service/wandu';

export default {
    namespace: 'search',
    state: {
        query: '',
        page: 1,
        total_page: 1,
        books: [],
        filter: [],
        para: {},
    },
    reducers: {
        setup_filter(state, action) {
            const res = action.payload;
            let filter = [
                {
                    name: '频道',
                    key: 's_channel',
                    value: 0,
                    options: res.find(item => item.key === 's_channel').values,
                },
                {
                    name: '分类',
                    key: 'tag',
                    value: 0,
                    options: res.find(item => item.key === 's_channel')
                        .values.reduce((arr, values) => {
                            values.tag_info.values.forEach(item => {
                                arr.push({
                                    ...item,
                                    rely: {
                                        k: 's_channel',
                                        v: values.id,
                                    }
                                })
                            })
                            return arr;
                        }, []),
                },
                {
                    name: '进度',
                    key: 'progress',
                    value: 0,
                    options: res.find(item => item.key === 'progress').values,
                },
                // {
                //     name: '排序',
                //     key: 'sort',
                //     value: 0,
                //     options: res.find(item => item.key === 'sort').values,
                // },
            ];
            let para = {};
            filter.forEach(item => {
                para[item.key] = item.value;
            });
            return Object.assign({}, state, { filter, para });
        },

        update_para(state, action) {
            const { tag, value } = action.payload;
            let para = {
                ...state.para,
            }
            para[tag] = value;
            if (tag === 's_channel') {
                para['tag'] = 0;
            }
            return Object.assign({}, state, {
                para,
                page: 1,
                total_page: 1,
            });
        },

        update_page(state, action) {
            return Object.assign({}, state, { page: action.payload.page });
        },

        update_res(state, action) {
            const payload = action.payload;
            if (payload) {
                return Object.assign({}, state, {
                    total_page: Number(action.payload.count_page),
                    page: Number(action.payload.page),
                    books: action.payload.list,
                })
            } else {
                return Object.assign({}, state, {
                    page: 1,
                    total_page: 1,
                    books: [],
                })
            }
        },

        update_query(state, action) {
            env.goto_page('/category');
            return Object.assign({}, state, {
                query: action.payload,
                page: 1,
                total_page: 1,
            });
        },
    },
    effects: {
        *query(action, { put }) {
            yield put({
                type: 'update_query',
                payload: action.payload,
            });
            yield put({ type: 'do_search' });
        },
        *check_tag(action, { put }) {
            yield put({
                type: 'update_para',
                payload: action.payload,
            });
            yield put({ type: 'do_search' });
        },
        *change_page(action, { put }) {
            yield put({
                type: 'update_page',
                payload: action.payload,
            });
            yield put({ type: 'do_search' });
        },
        *do_search(aciton, { put, select }) {
            const search = yield select(state => state.search);
            const res = yield wandu.filter_list({
                ...search.para,
                page: search.page,
                words: search.query
            }).catch(e => {
                console.log(e);
                return null;
            });
            yield put({
                type: 'update_res',
                payload: res,
            });
        },
        *init(action, { put }) {
            const res = yield wandu.get_classify().catch(e => {
                console.log(e);
                return [];
            })
            yield put({
                type: 'setup_filter',
                payload: res,
            });
        }
    },
}



// WEBPACK FOOTER //
// ./src/model/search.js